module.exports = __webpack_public_path__ + "img/defaultAvatar.b0a0e31.png";